<template>
  <v-row justify="start" align-content="center" class="py-1">
    <v-col
        cols="12"
        sm="3"
        md="4"
        class="text-left pt-3"
        align-self="end">
      <v-pagination
          v-model="page"
          :length="pages"
          :total-visible="totalVisible"
          @input="changeStep" />
    </v-col>
    <v-col
        cols="12"
        sm="9"
        md="8"
        class="text-left pt-1"
        align-self="center">
      <v-row justify="end" class="mx-0 px-0">
        <v-col
            class="text-left pt-4 mx-0 px-0"
            cols="6"
            sm="4"
            md="4"
            lg="3"
            align-self="end">
          {{ $t('Строк на странице') }}:
        </v-col>
        <v-col
            class="combobox-container ml-0 pl-0 pr-2"
            cols="3"
            sm="3"
            md="5"
            lg="4"
            align-self="center">
          <v-select
              v-model="itemsPerPage"
              v-test="{ select: 'itemsPerPage' }"
              small
              class="styled-combobox"
              single-line
              hide-details
              :items="rowsPerPageItems"
              item-value="value"
              item-text="text"
              return-object
              @change="changeRowCount" />
        </v-col>
        <v-col
            class="text-left pt-4"
            cols="3"
            sm="2"
            align-self="end">
          {{ $t('из') }} {{ value.totalCount }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style scoped>
.styled-combobox {
  /* min-width: 70px; */
  padding-left: 5px;
}
.combobox-container {
  max-width: 90px;
}
</style>

<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        width: window.innerWidth,
        itemsPerPage: null,
        page: 1,
        sortBy: [],
        sortDesc: [],
        rowsPerPageItems: [
          { text: 5, value: 5 },
          { text: 10, value: 10 },
          { text: 20, value: 20 },
          { text: 50, value: 50 },
          { text: this.$t('Все'), value: -1 }
        ]
      }
    },
    computed: {
      pages () {
        if (!this.value.totalCount) {
          return 0
        }
        if (this.value.itemsPerPage === -1 ||
          this.value.itemsPerPage >= this.value.totalCount) {
          return 1
        }
        return Math.ceil(
          this.value.totalCount / this.value.itemsPerPage
        )
      },
      totalVisible () {
        if (this.$vuetify.breakpoint.smAndDown) {
          return 3
        }
        if (this.$vuetify.breakpoint.lgAndDown) {
          return 5
        }
        return 7
      }
    },
    watch: {
      value: {
        deep: true,
        handler (newValue) {
          if (newValue.page !== this.page) {
            this.page = newValue.page
          }
          if (newValue.sortBy.length !== this.sortBy.length ||
            newValue.sortBy.some((val, index) => val !== this.sortBy[index]) ||
            newValue.sortDesc.length !== this.sortDesc.length ||
            newValue.sortDesc.some((val, index) => val !== this.sortDesc[index])) {
            this.$emit('changed', newValue)
          }
          this.sortBy = newValue.sortBy
          this.sortDesc = newValue.sortDesc
        }
      }
    },
    created () {
      this.itemsPerPage = this.rowsPerPageItems.find(rpp => rpp.value === this.value.itemsPerPage)
      this.page = this.value.page
    },
    methods: {
      changeStep: function (newValue) {
        const newPagination = {
          ...this.value,
          page: newValue
        }
        this.$emit('changed', newPagination)
        this.$emit('input', newPagination)
      },
      changeRowCount: function (newValue) {
        const newPagination = {
          ...this.value,
          itemsPerPage: newValue.value
        }
        this.$emit('input', newPagination)
        this.$emit('changed', newPagination)
      }
    }
  }
</script>
